;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { tourStep } from "@/features/onboarding-tours/orchestrator/tour-step-builder";
import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { defineTour } from "@/features/onboarding-tours/registry/define-tour";
import { buildCreateDataProviderDialogSteps } from "@/features/onboarding-tours/registry/tours/create-data-provider-dialog-steps";
import { TourCategory } from "@/features/onboarding-tours/types/tour-category";

const visualizationGuardConnectTarget = tourSelector(
	TOUR_TARGETS.visualizationGuardConnect,
);
const addDataProviderButtonTarget = tourSelector(
	TOUR_TARGETS.addDataProviderButton,
);

export const addDataProviderGuardTour = defineTour({
	buildSteps: () => [
		tourStep({
			content:
				"Your workspace needs a data provider before you can view this page. Click Add Data Providers to start setup.",
			data: {
				advanceOn: "target-click",
				hidePrimary: true,
				watchTargetClick: {
					selector: visualizationGuardConnectTarget,
					stepIndex: 1,
				},
			},
			hideOverlay: false,
			placement: "bottom",
			scrollBefore: visualizationGuardConnectTarget,
			spotlightPadding: 8,
			target: visualizationGuardConnectTarget,
			title: "Connect your data",
		}),
		...buildCreateDataProviderDialogSteps({
			content:
				"Choose a provider, authenticate with the required credentials where applicable, then submit to connect. Some providers may require additional setup steps before a successful connection is established. Finish the tour when you are ready — you can complete setup or close the dialog on your own.",
			title: "Connect your provider",
		}),
	],
	catalog: { hidden: true },
	category: TourCategory.dataIntegrations,
	description:
		"Connect a data provider to unlock dashboards and analytics for this workspace.",
	eligibility: {},
	handoff: { nextTourId: "invite-team-member" },
	id: "add-data-provider-guard",
	launch: {
		startOnCurrentPage: true,
	},
	tags: ["data provider", "integration", "connect", "guard"],
	title: "Connect your first data provider",
});

export const addDataProviderSettingsTour = defineTour({
	buildSteps: ({ framing }) => [
		tourStep({
			content:
				framing === "add-more-providers"
					? "Click Add Data Provider to connect another integration."
					: "Click Add Data Provider to connect a data source for this workspace.",
			data: {
				advanceOn: "target-click",
				hidePrimary: true,
				watchTargetClick: {
					selector: addDataProviderButtonTarget,
					stepIndex: 1,
				},
			},
			placement: "left",
			scrollBefore: addDataProviderButtonTarget,
			spotlightPadding: 8,
			target: addDataProviderButtonTarget,
			title:
				framing === "add-more-providers"
					? "Add another provider"
					: "Add a data provider",
			waitForTarget: true,
		}),
		...buildCreateDataProviderDialogSteps({
			content:
				"Choose a provider, complete credentials or OAuth if prompted, then submit to connect. Finish the tour when you are ready — you can complete setup or close the dialog on your own.",
			title: "Connect your provider",
		}),
	],
	catalog: {},
	category: TourCategory.dataIntegrations,
	description:
		"Connect data providers and integrations from workspace settings.",
	eligibility: {},
	id: "add-data-provider-settings",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/settings?tab=workspace`,
	},
	tags: ["data provider", "settings", "integration", "connect"],
	title: "Add a data provider",
});
